import React from 'react'
import { withClientId } from 'hocs'
import { Button, Row, Col, Select, notification } from 'elements'
import { socketUri } from 'index'
import { listProgrammes } from "redux/modules/model/holder";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { programmesSelector } from "redux/selectors";
import { connect } from "react-redux";

class ExportReport extends React.Component{
  constructor(props) {
  super(props)
    this.state = {
      programme: '',
      loading: false
    }
  }

  componentDidMount(){
    const { clientId, listProgrammes } = this.props
    listProgrammes({clientId})
  }

  handleProgrammeChange = programme => {
    this.setState({programme})
  }

  handleFilterOption = (input, option) => {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }
  openNotification = (title,msg) => {
    notification.open({
      message: title,
      description: msg,
      placement: "topRight",
    });
  };

  downLoadReport = () => {
    const { clientId } = this.props
    const { programme } = this.state
    const encodedUri = encodeURI(`//${socketUri}/api/v1/attendance/download/report/${clientId}/${programme}`);
    this.setState({loading: true});
    this.openNotification('Generating Report', 'This may take a little time.')
    const programName = programme.replace(' ', '_');
    fetch(encodedUri).then(res => {
      return res.blob()})
      .then(
        blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `UCL-Attendance-Report-${programName}.xlsx`;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
        },
        err => console.log('Err',err)
      )
      .then(()=> this.setState({loading: false}))
  }

  render(){
    const { programmesList } = this.props
    const { programme, loading } = this.state
    return(
      <Row type="flex" align="middle" gutter={12} style={{padding: '40px 20px'}}>
        <Col xs={24} sm={3} style={{margin: '5px 0'}}>Programme:</Col>
        <Col xs={24} sm={6} style={{margin: '5px 0'}}>
          <Select
            showSearch
            value={programme}
            style={{ width: '100%' }}
            placeholder="Select a programme"
            optionFilterProp="children"
            filterOption={this.handleFilterOption}
            onChange={this.handleProgrammeChange}
          >
            {programmesList.map((programme, index) => (
              <Select.Option value={programme} key={index}>{programme}</Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={6} style={{margin: '5px 0'}}>
          <Button
            disabled={!programme}
            loading={loading}
            onClick={this.downLoadReport}
          >
            Download Report
          </Button>
        </Col>
      </Row>
    )
  }
}

const selector = createStructuredSelector({
  programmesList: programmesSelector
})

const actions = {
  listProgrammes,
}

export default compose(
  withClientId,
  connect(selector, actions)
)(ExportReport)



// WEBPACK FOOTER //
// ./src/smart-components/export-report-attendance/index.js